import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';
import icInfo from 'assets/svg/ic_info_transparent.svg';
import Tooltip from 'src/Pages/Staking/Components/Tooltip';

const Title = ({
  title,
  className,
  tooltip
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rectangle
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title), tooltip && /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltip,
    color: "#3C32AF",
    className: styles.tooltip
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo
  })));
};

export default Title;